module.exports = __webpack_public_path__ + "LG_G6_icon.svg?71ef091bb24e37e44f38da3a48dd1bce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/LG_G6_icon.svg
// module id = 198
// module chunks = 0